import Chip from '@mui/material/Chip'

import { STATUS_CONFIG } from './config'

export default function StatusChip({ status }) {
  const cfg = STATUS_CONFIG[status]
  if (!cfg) return null

  const { label, Icon, color, bg, border } = cfg

  return (
    <Chip
      size="small"
      icon={<Icon sx={{ fontSize: 16, color: `${color} !important` }} />}
      label={label}
      //   label={count > 1 ? `${label} · ${count} intentos` : label}
      sx={{
        height: 26,
        borderRadius: '13px',
        bgcolor: bg,
        border: `1px solid ${border}`,
        width: '100%',
        color,
        fontSize: 13,
        fontWeight: 500,
        '& .MuiChip-label': { px: '8px' },
        '& .MuiChip-icon': { ml: '6px', mr: '-2px' },
      }}
    />
  )
}
